// src/components/questions/abQuestion/ABQuestion.jsx
import React from "react";
import "./abQuestion.css";

/**
 * ABQuestion es un componente controlado.
 * Recibe `value` (la opción seleccionada) y notifica cambios con `updateProgress`.
 */
const ABQuestion = ({
  question,
  optionA,
  optionB,
  required,
  value = "",
  updateProgress
}) => {
  const handleClick = option => {
    updateProgress(option);
  };

  return (
    <div className="ab-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="ab-options">
        <button
          type="button"
          className={`ab-button ${value === optionA ? "selected" : ""}`}
          onClick={() => handleClick(optionA)}
        >
          {optionA}
        </button>
        <button
          type="button"
          className={`ab-button ${value === optionB ? "selected" : ""}`}
          onClick={() => handleClick(optionB)}
        >
          {optionB}
        </button>
      </div>
    </div>
  );
};

export default ABQuestion;
